/**
 * @generated SignedSource<<8bd7d4e41486c1532c3b6c40196bfb04>>
 * @relayHash 60bd18d1ebe1973c1c8378f57e31a48c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60bd18d1ebe1973c1c8378f57e31a48c

import { ConcreteRequest } from 'relay-runtime';
export type ChMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE" | "TEMPLATE";
export type useChMedicationSearchQuery$variables = {
  appointmentId?: string | null;
  includeTemplates: boolean;
  patientId: string;
  searchTerm: string;
};
export type useChMedicationSearchQuery$data = {
  readonly ch_medicationSearch: {
    readonly results: ReadonlyArray<{
      readonly category: string | null;
      readonly dispensingCategory: string | null;
      readonly formattedPrice: string | null;
      readonly highlights: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }> | null;
      readonly id: string;
      readonly itemId: number;
      readonly mainSubstance: string | null;
      readonly medicationType: ChMedicationType;
      readonly name: string;
      readonly packageSizeDescription: string | null;
      readonly pharmacode: number | null;
      readonly refundCategory: string | null;
      readonly searchScore: number | null;
      readonly therapyDurationDays: number | null;
    }>;
  };
};
export type useChMedicationSearchQuery = {
  response: useChMedicationSearchQuery$data;
  variables: useChMedicationSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appointmentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTemplates"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      },
      {
        "kind": "Variable",
        "name": "includeTemplates",
        "variableName": "includeTemplates"
      },
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      },
      {
        "kind": "Literal",
        "name": "top",
        "value": 100
      }
    ],
    "concreteType": "SearchClientResponseOfMedicationSearchResult",
    "kind": "LinkedField",
    "name": "ch_medicationSearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MedicationSearchResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pharmacode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medicationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "searchScore",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfStringAndString",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dispensingCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "packageSizeDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refundCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mainSubstance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formattedPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "therapyDurationDays",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChMedicationSearchQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useChMedicationSearchQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "id": "60bd18d1ebe1973c1c8378f57e31a48c",
    "metadata": {},
    "name": "useChMedicationSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f98f6cc15bf0e47068e27f13d18ce44c";

export default node;
